import * as React from 'react'
import Coupon from '../../models/Coupon'
import Icon from 'components/Icon'
import Spinner from 'components/Spinner'
import IconVisual from 'components/IconVisual'
import {
  BillingItemList,
  BillingItem,
  BillingItemVisual,
  BillingItemContent,
  BillingItemTitle,
  BillingItemSubtitle,
  BillingItemExtras,
  BillingItemBadge,
} from '../BillingItemList'

interface CouponListProps {
  children?: React.ReactNode
}

/**
 * The CouponList
 */
export function CouponList({ children }: CouponListProps) {
  return <BillingItemList>{children}</BillingItemList>
}

interface CouponListItemProps {
  coupon: Coupon
  selected?: boolean
  onClick?: () => unknown
  busy?: boolean
  disabled?: boolean
}

/**
 " Coupon List Item
 */
export function CouponListItem({
  coupon,
  selected,
  onClick,
  disabled,
  busy,
}: CouponListItemProps) {
  return (
    <BillingItem aria-selected={selected} onClick={onClick} disabled={disabled}>
      <BillingItemVisual>
        <IconVisual>
          <Icon size={36} name="coupons" />
        </IconVisual>
      </BillingItemVisual>
      <BillingItemContent>
        <BillingItemTitle>{coupon.friendlyName}</BillingItemTitle>
        <BillingItemSubtitle>
          {coupon.code}
          {coupon.description && <> | {coupon.description}</>}
        </BillingItemSubtitle>
      </BillingItemContent>
      <BillingItemExtras>
        {selected && <BillingItemBadge>Current</BillingItemBadge>}
        {busy && <Spinner />}
      </BillingItemExtras>
    </BillingItem>
  )
}
